import { defineStore } from 'pinia';

export const useCylinderConfigurationStore = defineStore('cylinderConfiguration', {
   state: () => ({
      data: {
         product: {},
         loading: false,
         watcherActivated: false,
         refreshKey: 0,
         cylinderQty: 0,
         cylinderCopy: false,
         sliceIndex: 0,
         previousActiveCylinderIndex: -1,
         totals: null,
         showWizard: false,
         focusIndex: 0,
         selectedCylinderForSmartlock: false,
         setImage: null,
         setImageLoading: false,
         text_blocks: null,
         keyOptionIsShowed: false,
         chosenQty: 0,
         showMoreCylinders: false,
      },
      form: {
         product_id: 0,
         errors: {},
         cylinders: [],
         padlocks: [],
         rimlocks: [],
         qtySelected: false,
         keysSelected: false,
         cylindersValid: false,
         upsellItems: [],
         upsellIds: [],
         keys: {
            qty: 0,
            default: 0,
            colors: [],
            customColors: false,
         },
         file: false,
         customPrice: null,
         comment: '',
         reference: '',
         clearErrors(field) {
            if (field) {
               delete this.errors[field]
            } else {
               this.errors = {}
            }
         },
      },
      disableCylinders: false,
      stepsCompleted: false,
      overlay: false,
      collapsed: false,
      isOverviewExpanded: false,
      activeStep: 1,
      mobileSteps: [],
      loadingCart: false,
      loadingCheckout: false,
      isOpen: false,
      swipeLeft: false,
      swipeRight: false,
   }),

   getters: {
      // Memoized getters to prevent unnecessary recalculations
      totals: (state) => state.data.totals,
      formData: (state) => state.form,
      isCalculating: (state) => state.data.loading,
      textBlocks: (state) => state.data.text_blocks,
   },

   actions: {
      setData(data) {
         // Only update if the data has actually changed
         Object.entries(data).forEach(([key, value]) => {
            if (JSON.stringify(this.data[key]) !== JSON.stringify(value)) {
               this.data[key] = value
            }
         })
      },

      setForm(data) {
         // Only update if the data has actually changed
         Object.entries(data).forEach(([key, value]) => {
            if (JSON.stringify(this.form[key]) !== JSON.stringify(value)) {
               this.form[key] = value
            }
         })
      },

      setIsOpen(value) {
         this.isOpen = value
      },

      setStepsCompleted(value) {
         if (this.stepsCompleted !== value) {
            this.stepsCompleted = value
         }
      },

      toggleCollapsed() {
         this.collapsed = !this.collapsed
         this.overlay = this.collapsed
      },

      setMobileSteps(steps) {
         this.mobileSteps = steps
      },

      setActiveStep(step) {
         this.activeStep = step
      },

      setDisableCylinders(value) {
         this.disableCylinders = value
      },
   },
}) 